import css from './wordListFilters.module.scss';

import { memo } from 'react';

import { Menu, MenuItem } from 'core/ui/Menu';
import ICONS, { Icon } from 'core/ui/icons';

import { ALL_WORD_SORTS, TWordSort } from '../../../shared/types/domain';

function SortMenu({
  setFilter,
  sort,
}: {
  setFilter: (key: 'sort', value: TWordSort) => void;
  sort: TWordSort;
}) {
  return (
    <Menu
      anchor={({ toggle, setRef }) => (
        <Icon
          icon="Sort"
          className={css.filterButton}
          onClick={toggle}
          ref={setRef}
        />
      )}
    >
      {ALL_WORD_SORTS.map(v => (
        <MenuItem
          icon={ICONS.Sort}
          onClick={() => setFilter('sort', v)}
          key={v}
          active={v === sort}
          label={LABELS[v]}
        />
      ))}
    </Menu>
  );
}

export default memo(SortMenu);

const LABELS: Record<TWordSort, string> = {
  'pending-first': 'Pending first',
  'pending-last': 'Done first',
  newest: 'Newest first',
  oldest: 'Oldest first',
};
